import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cart.png'
import _imports_1 from '@/assets/images/close.png'


const _withScopeId = n => (_pushScopeId("data-v-1cbb7096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-item card my-3" }
const _hoisted_2 = { class: "product-bottom" }
const _hoisted_3 = { class: "prod-title" }
const _hoisted_4 = { class: "prod-info" }
const _hoisted_5 = { class: "prod-price" }
const _hoisted_6 = { class: "prod-cart" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "closeButton" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "title mb-2" }
const _hoisted_13 = { class: "info d-flex w-100 justify-content-between" }
const _hoisted_14 = { class: "pr-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "mt-2 mb-1" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6 pr-1" }
const _hoisted_21 = { class: "col-md-6 pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "img",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('products/' + _ctx.product.url_key))),
      style: _normalizeStyle(
        'background-image: url(' +
        _ctx.getMainImage() +
        '); height: ' +
        _ctx.height +
        '; min-height: ' +
        _ctx.height
      )
    }, [
      _createElementVNode("div", {
        class: "hover-image",
        style: _normalizeStyle('background-image: url(' + _ctx.getOther() + ')')
      }, null, 4)
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: '/products/' + _ctx.product.url_key
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, _toDisplayString(_ctx.product.name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.product.price), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPops && _ctx.showPops(...args))),
            class: "showPops"
          }, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["product-pops", { active: _ctx.showPanel }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPops && _ctx.showPops(...args))),
          class: "closePanel"
        }, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.product.name), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("product.stock")) + ":", 1),
          (this.length != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("product.length")) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("product.price")) + ":", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, _toDisplayString(_ctx.product.quantity) + " " + _toDisplayString(_ctx.$t("product.stockAmount", _ctx.product.quantity)), 1),
          (this.length != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.length) + "cm", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(_ctx.product.price), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "btn btn-main w-100 mb-1",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('products/' + _ctx.product.url_key)))
        }, _toDisplayString(_ctx.$t("product.moreInfo")), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.amount) = $event))
          }, null, 512), [
            [_vModelText, _ctx.amount]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addToCart && _ctx.addToCart(...args))),
            class: "addToCart"
          }, _toDisplayString(_ctx.$t("product.addToCart")), 1)
        ])
      ])
    ], 2)
  ]))
}